import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import React from 'react';
import { styled } from 'linaria/react';
import MaxWidth from '../Layout/MaxWidth';
import { theme } from '../Theme';

export const CategoryHeaderWrapper = styled(MaxWidth)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 20px;
  ${theme.below.lg} {
    max-width: 100%;
    width: 100%;
    padding: 10px 20px 0px 20px;
  }
`;

export const NoImageWrapper = styled('div')`
  margin-top: 3.5rem;
  padding: 10px;
`;

const CategoryName = styled('h1')`
  font-weight: 600;
  line-height: normal;
  font-size: 30px;
  margin-bottom: 10px;
  ${theme.below.lg} {
    font-size: 20px;
  }
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 8px !important;
  color: #333333;
  li,
  a {
    color: #333333 !important;
    &:after {
      font-weight: 300;
    }
  }

  li {
    font-weight: 700;
    &:last-of-type {
      &:after {
        display: none;
      }
    }
  }
  a {
    text-decoration: none;
    font-weight: 300;
  }
`;

export const Inner = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .category-image {
    max-width: 100%;
    margin-bottom: 10px;
  }
`;

const CategoryHeader = ({ category, parents }) => {
  const breadcrumbProps = {
    breadcrumbText: category.breadcrumbText,
    parents
  };
  return (
    <CategoryHeaderWrapper>
      <Inner>
        <StyledBreadcrumbs {...breadcrumbProps} />
        {category?.images?.length > 0 && category?.parent?.id !== 559 && (
          <div className="category-image">
            <img src={category.images[4].url} alt={category.name} />
          </div>
        )}
        <CategoryName data-testid="page-header">
          {category.mainHeader ? category.mainHeader : category.name}
        </CategoryName>
      </Inner>
    </CategoryHeaderWrapper>
  );
};

export default CategoryHeader;
